// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__13O6q","title":"ClientCherryInfo_title__2-q08","itemText":"ClientCherryInfo_itemText__2TtvH"};